"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CreateProjectModal_1 = __importDefault(require("./CreateProjectModal"));
exports.default = CreateProjectModal_1.default;
